<!-- <h1>{{title}}</h1> -->
<!-- <app-header></app-header> -->
<!-- <div class="setanimate" [@listAnimation]="o && o.activatedRouteData && o.activatedRouteData['animation']"> -->
<!-- <div [@myAnimation]="o.isActivated ? o.activatedRoute : ''"> #o="outlet" -->
<router-outlet (activate)="onActivate($event)"></router-outlet>
<!-- <div> -->
<!-- <img class="scrollTop mblview back-to-top" *ngIf="isShow" (click)="gotoTop()" src="./assets/img/uparrow.png" width="33px;"> -->
<!-- </div> -->

<!-- </div> -->
<!-- <app-footer></app-footer> -->
